import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import apiClient from "../../services/apiClient";
import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

const AdminStoryDetail = () => {
  const { id } = useParams();
  const [chapters, setChapters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedChapter, setExpandedChapter] = useState(null);
  const [newChapterTitle, setNewChapterTitle] = useState("");
  const [newChapterContent, setNewChapterContent] = useState("");
  const [categories, setCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [author, setAuthor] = useState("");
  const [source, setSource] = useState("");
  const [status, setStatus] = useState("in_progress");

  useEffect(() => {
    const fetchChapters = async () => {
      try {
        const response = await apiClient.get(`/api/v1/stories/${id}/chapters`);
        setChapters(response.data);
        setLoading(false);
        if (response.data.length > 0) {
          setExpandedChapter(response.data[0].id);
        }
      } catch (error) {
        console.error("Error fetching chapters:", error);
        setLoading(false);
      }
    };

    const fetchCategories = async () => {
      try {
        const response = await apiClient.get("/api/v1/categories");
        setCategories(response.data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchChapters();
    fetchCategories();
  }, [id]);

  const handleDeleteChapter = async (chapterId) => {
    try {
      await apiClient.delete(`/api/admin/chapters/${chapterId}`);
      setChapters(chapters.filter(chapter => chapter.id !== chapterId));
    } catch (error) {
      console.error("Error deleting chapter:", error);
    }
  };

  const handleAddChapter = async () => {
    try {
      const response = await apiClient.post(`/api/admin/chapters`, {
        title: newChapterTitle,
        content: newChapterContent,
        story_id: id,
        categories: selectedCategories,
        author,
        source,
        status,
      });
      setChapters([...chapters, response.data]);
      setNewChapterTitle("");
      setNewChapterContent("");
      setSelectedCategories([]);
      setAuthor("");
      setSource("");
      setStatus("in_progress");
    } catch (error) {
      console.error("Error adding chapter:", error);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Chapters for Story ID: {id}</h1>
      <div className="mb-4">
        <h2 className="text-xl">Add New Chapter</h2>
        <input
          type="text"
          value={newChapterTitle}
          onChange={(e) => setNewChapterTitle(e.target.value)}
          placeholder="Chapter Title"
          className="border p-2 mb-2 w-full"
        />
        <textarea
          value={newChapterContent}
          onChange={(e) => setNewChapterContent(e.target.value)}
          placeholder="Chapter Content"
          className="border p-2 mb-2 w-full"
          rows="4"
        />
        <select
          multiple
          value={selectedCategories}
          onChange={(e) => setSelectedCategories([...e.target.selectedOptions].map(option => option.value))}
          className="border p-2 mb-2 w-full"
        >
          {categories.map((category) => (
            <option key={category.id} value={category.id}>{category.name}</option>
          ))}
        </select>
        <input
          type="text"
          value={author}
          onChange={(e) => setAuthor(e.target.value)}
          placeholder="Author"
          className="border p-2 mb-2 w-full"
        />
        <input
          type="text"
          value={source}
          onChange={(e) => setSource(e.target.value)}
          placeholder="Source"
          className="border p-2 mb-2 w-full"
        />
        <select
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          className="border p-2 mb-2 w-full"
        >
          <option value="in_progress">Đang ra</option>
          <option value="completed">Đã hoàn thành</option>
          <option value="stopped">Đã tạm dừng</option>
        </select>
        <button onClick={handleAddChapter} className="bg-blue-500 text-white p-2 rounded">
          Add Chapter
        </button>
      </div>
      {chapters.length === 0 ? (
        <p>No chapters found for this story.</p>
      ) : (
        chapters.map((chapter) => (
          <div key={chapter.id} className="mb-4 border p-4 rounded">
            <h2 className="text-xl font-semibold flex justify-between items-center">
              <Link to={`/admin/chapters/${chapter.id}`} className="text-blue-500 hover:underline">
                {chapter.title}
              </Link>
              <div>
                <IconButton onClick={() => handleDeleteChapter(chapter.id)} className="text-red-500">
                  <DeleteIcon />
                </IconButton>
                <Link to={`/admin/chapters/${chapter.id}/edit`}>
                  <IconButton className="text-green-500">
                    <EditIcon />
                  </IconButton>
                </Link>
              </div>
            </h2>
            <button onClick={() => setExpandedChapter(expandedChapter === chapter.id ? null : chapter.id)} className="text-blue-500">
              {expandedChapter === chapter.id ? "Collapse" : "Expand"}
            </button>
            {expandedChapter === chapter.id && (
              <div className="whitespace-pre-line text-justify leading-7 mt-2">
                {chapter.content}
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
};

export default AdminStoryDetail; 